export default __webpack_public_path__ + "static/media/favicon.de92238a.svg";